/**
 * Ajoute l'en-tête `Accept-Language` (langue choisie dans l'interface) à toutes les requêtes vers les API ZOS,
 * sans toucher aux appels un par un. Les serveurs peuvent ainsi répondre dans la langue de l'utilisateur
 * (l'Assistant ZOS s'en sert). `Accept-Language` est un en-tête CORS « simple » : pas de requête préalable.
 * Les appels vers d'autres hôtes (appareil en appairage local, CDN…) ne sont pas modifiés.
 */
const API_BASES = [
  import.meta.env.VITE_WATTELZCE_API_URL,
  import.meta.env.VITE_DEVICE_SERVICE_URL,
  import.meta.env.VITE_MQTT_SERVICE_URL,
].filter((u): u is string => typeof u === 'string' && u.length > 0);

function isApiRequest(url: string): boolean {
  if (url.startsWith('/api/')) return true;
  return API_BASES.some(base => url.startsWith(base));
}

let installed = false;

export function installApiLanguageHeader(getLanguage: () => string): void {
  if (installed || typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  installed = true;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    if (!isApiRequest(url)) return nativeFetch(input, init);
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    if (!headers.has('Accept-Language')) headers.set('Accept-Language', getLanguage());
    return nativeFetch(input, { ...init, headers });
  };
}
